import { render, staticRenderFns } from "./ApplyAftersale.vue?vue&type=template&id=f7697f80&scoped=true"
import script from "./ApplyAftersale.vue?vue&type=script&lang=js"
export * from "./ApplyAftersale.vue?vue&type=script&lang=js"
import style0 from "./ApplyAftersale.vue?vue&type=style&index=0&id=f7697f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7697f80",
  null
  
)

export default component.exports